import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import { Toaster } from "./components/ui/sonner";
import { ThemeProvider } from "./contexts/ThemeContext";

// Pages
import LoginPage from "./pages/LoginPage";
import PortfolioPulsePage from "./pages/PortfolioPulsePage";
import ProgramsPage from "./pages/ProgramsPage";
import ProjectsPage from "./pages/ProjectsPage";
import UploadDownloadPage from "./pages/UploadDownloadPage";
import PortfolioBoardPage from "./pages/PortfolioBoardPage";
import ITMetricsDashboardPage from "./pages/ITMetricsDashboardPage";

// Components
import Layout from "./components/Layout";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DataSeeder = ({ children }) => {
  const [seeded, setSeeded] = useState(false);

  useEffect(() => {
    const seedData = async () => {
      try {
        await axios.post(`${API}/seed`);
      } catch (error) {
        console.error("Seed request failed:", error);
      }
      setSeeded(true);
    };
    seedData();
  }, []);

  if (!seeded) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]">
        <div className="text-center">
          <div className="w-12 h-12 border-3 border-[#00C26D]/30 border-t-[#00C26D] rounded-full animate-spin mx-auto" />
          <p className="text-slate-500 mt-4">Initializing application...</p>
        </div>
      </div>
    );
  }

  return children;
};

DataSeeder.propTypes = {
  children: PropTypes.node.isRequired,
};

function App() {
  const [authed, setAuthed] = useState(() => sessionStorage.getItem("po_auth") === "1");

  if (!authed) {
    return <LoginPage onLogin={() => setAuthed(true)} />;
  }

  return (
    <ThemeProvider>
      <DataSeeder>
        <div className="App min-h-screen bg-[#F8FAFC] dark:bg-[#1A1A1A] transition-colors duration-300">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Navigate to="/app/portfolio-pulse" replace />} />

              <Route path="/app" element={<Layout />}>
                <Route index element={<Navigate to="/app/portfolio-pulse" replace />} />
                <Route path="portfolio-pulse" element={<PortfolioPulsePage />} />
                <Route path="programs" element={<ProgramsPage />} />
                <Route path="projects" element={<ProjectsPage />} />
                <Route path="upload-download" element={<UploadDownloadPage />} />
                <Route path="portfolio-board" element={<PortfolioBoardPage />} />
                <Route path="it-metrics" element={<ITMetricsDashboardPage />} />
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </div>
      </DataSeeder>
    </ThemeProvider>
  );
}

export default App;
